module.exports = __webpack_public_path__ + "static/media/california_caviar_salmon.3ef5c1aa.webp";